export default __webpack_public_path__ + "static/media/HeaderSideBar.bce7bd64.svg";